import NextLink from "next/link";
import type { ComponentProps } from "react";

export type LinkProps = ComponentProps<typeof NextLink>;

/**
 * Application-wide `Link`.
 *
 * Prefetching is disabled on purpose: every prefetch is an edge-middleware +
 * RSC request, and the store layout fetch behind it (config, menu, builder,
 * session, promotions) is expensive. Product grids and carousels put dozens of
 * links in the viewport at once, so the background requests cost far more than
 * the click-time navigation they save.
 *
 * Client-side navigation on click is unchanged. Import this instead of
 * `next/link`; `src/__tests__/perf-invariants.spec.ts` enforces that.
 */
export default function Link(props: LinkProps) {
	return <NextLink {...props} prefetch={false} />;
}
